export default "__VITE_ASSET__BFq5$n18__"